import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion'; // استيراد motion من framer-motion
import { Link } from 'react-router-dom'; // React Router

// الصور
import TouristAttraction from '../assets/images.png';
import hamam from '../assets/hmam';
import mntj3 from '../assets/3311351-200.png';
import shopping from '../assets/download (1).png';
import rihal from '../assets/Rihal2_logo-black-rgb.svg';

const OffersPageInLandingPage = ({ scrollY }) => {
  const sectionRef = useRef(null); // مرجع لمراقبة التقاطع
  const [inView, setInView] = useState(false); // تتبع ما إذا كان القسم في العرض

  // مراقب التقاطع للتحريك عند التمرير
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        setInView(entry.isIntersecting); // التفعيل عند ظهور القسم في العرض
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div className="w-full h-max flex flex-col items-center mt-6 ">
      <motion.h1
      style={{fontFamily:"Reem Kufi"}}
        className="text-3xl md:text-5xl lg:text-7xl text-center my-10 text-[#0B4B41] font-bold px-4"
        initial={{ opacity: 0, y: -50 }}
        animate={{
          opacity: scrollY > 500 ? 1 : scrollY > 200 ? scrollY / 500 : 0,
          y: scrollY > 500 ? 0 : -50,
        }}
        transition={{
          delay: 0.9,
          type: 'spring',
          stiffness: 50,
        }}
      >
        اكتشف معنا متعة السفر الحلال
      </motion.h1>

      {/* التنقل بين الأقسام */}
      <div
        className="w-full flex flex-wrap justify-center items-center gap-4 md:gap-8 px-4 max-w-7xl"
        ref={sectionRef}
      >
        {[
          { to: "/TouristAttractionPage", src: TouristAttraction, label: "دليل سياحي" },
          { to: "/Public-Bathes", src: hamam, label: "حمامات" },
          { to: "/TouristResorts", src: mntj3, label: "منتجعات" },
          { to: "/Shopping", src: shopping, label: "تسوق" },
          { to: "/RihalOffers", src: rihal, label: "عروض رحال" },
        ].map((item, index) => (
          <motion.div
          
            key={index}
            className="bg-white p-4 sm:p-6 rounded-lg w-full sm:w-60 md:w-72 lg:w-80 flex justify-center items-center flex-col hover:scale-105 hover:shadow-xl transition-all duration-300"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 50 }}
            transition={{ duration: 0.5, type: "spring", stiffness: 50 }}
          >
            <Link to={item.to} className="flex justify-center items-center flex-col text-center">
              <img
                src={item.src}
                alt={item.label}
                className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain mb-4"
              />
              <span className="text-sm sm:text-lg md:text-xl font-semibold">{item.label}</span>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default OffersPageInLandingPage;
